import type { TmsInvoiceDetail, TmsInvoiceRow, TmsLoadRow } from '@numeo/types-main-web-app'
import type { CardView, ListPage } from './cardResults'

/** The pages a card has read in place ("Load more"): their rows, in order, and the next page the last one named. */
export interface PagedRows {
    rows: Record<string, unknown>[]
    nextPage?: number
}

/**
 * A list card's view with the rows read in place appended. Its page now covers every row shown, so its totals and "Show more" read
 * the same rows the table draws. A view that is not a list, or a card with no page, is returned as it is.
 */
export function pagedView(view: CardView, paged: PagedRows | undefined): CardView {
    if (!paged || !paged.rows.length) return view
    if (view.view === 'loads' && view.page) {
        const rows = [...view.rows, ...(paged.rows as unknown as TmsLoadRow[])]
        return { ...view, rows, page: nextPageOf(view.page, rows.length, paged.nextPage) }
    }
    if (view.view === 'invoices' && view.page) {
        const rows = [...view.rows, ...(paged.rows as unknown as TmsInvoiceRow[])]
        return { ...view, rows, page: nextPageOf(view.page, rows.length, paged.nextPage) }
    }
    if (view.view === 'invoice-preview' && view.page) {
        const invoices = [...view.invoices, ...(paged.rows as unknown as TmsInvoiceDetail[])]
        return { ...view, invoices, page: nextPageOf(view.page, invoices.length, paged.nextPage) }
    }
    return view
}

/** The page after rows were read in place: it shows every row now drawn, from the same first position, and names the last next page. */
const nextPageOf = (page: ListPage, shown: number, nextPage: number | undefined): ListPage => ({ ...page, shown, nextPage })
